














import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseComponent from '../../core/base.component';

@Component({
  name: 'BaseCard',
})
export default class BaseCard extends BaseComponent {
  @Prop() readonly title: string;
  @Prop({ default: false }) readonly hideTitle: boolean;
  @Prop({ default: true }) noBody: boolean;
}
